import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Spinner from '../../components/utilities/Spinner';
import PortalCheck from '../../utility/PortalCheck';

const DataMiningPortal = lazy(() => import('./datamining'));
const VASPortal = lazy(() => import('./vas'));
const AboutPortal = lazy(() => import('./about'));
const OutdoorPortal = lazy(() => import('./outdoor'));
const ExchangePortal = lazy(() => import('./exchange'));
const FinancePortal = lazy(() => import('./finance'));
const RankingPortal = lazy(() => import('./ranking'));
const DiscountPortal = lazy(() => import('./discount'));
const QR = lazy(() => import('./qr'));
const AutoBillingPortal = lazy(() => import('./autoBilling'));
const MeetingPortal = lazy(() => import('./meeting'));
const FifteenOff = lazy(() => import('./fifteenOff'));
const SPLPortal = lazy(() => import('./spl'));
const MarketingPortal = lazy(() => import('./marketing'));

const StoreRoutes = () => {
    const portalAccessList = useSelector(state => state?.auth?.loginData?.portalIcon?.store)

    if (!portalAccessList) {
        return (
            <Suspense fallback={<div className="spin"><Spinner /></div>}>
                <Routes>
                    <Route path="/marketing/*" element={<MarketingPortal />} />
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </Suspense>
        );
    }
    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spinner />
                </div>
            }
        >
                <Routes>
                    <Route path="/mining/*" element={<PortalCheck portalPath="/store/mining/dashboard" portalList={portalAccessList}><DataMiningPortal /></PortalCheck>} />
                    <Route path="/about/*" element={<PortalCheck portalPath="/store/about/dashboard" portalList={portalAccessList}><AboutPortal /></PortalCheck>} />
                    <Route path="/outdoor/*" element={<PortalCheck portalPath="/store/about/dashboard" portalList={portalAccessList}><OutdoorPortal /></PortalCheck>} />
                    <Route path="/exchange/*" element={<PortalCheck portalPath="/store/exchange/dashboard" portalList={portalAccessList}><ExchangePortal /></PortalCheck>} />
                    <Route path="/finance/*" element={<PortalCheck portalPath="/store/finance/dashboard" portalList={portalAccessList}><FinancePortal /></PortalCheck>} />
                    <Route path="/manager/*" element={<PortalCheck portalPath="/store/manager/dashboard" portalList={portalAccessList}><DiscountPortal /></PortalCheck>} />
                    <Route path="/vas/*" element={<PortalCheck portalPath="/store/vas/dashboard" portalList={portalAccessList}><VASPortal /></PortalCheck>} />
                    <Route path="/ranking/*" element={<PortalCheck portalPath="/store/ranking/dashboard" portalList={portalAccessList}><RankingPortal /></PortalCheck>} />
                    <Route path="/qr/*" element={<PortalCheck portalPath="/store/qr/dashboard" portalList={portalAccessList}><QR /></PortalCheck>} />
                    <Route path="/spl/*" element={<PortalCheck portalPath="/store/spl/dashboard" portalList={portalAccessList}><SPLPortal /></PortalCheck>} />
                    <Route path="/marketing/*" element={<MarketingPortal />} />
                    <Route path="/review_offer/*" element={<PortalCheck portalPath="/store/review_offer/dashboard" portalList={portalAccessList}><FifteenOff /></PortalCheck>} />
                    <Route path="/auto_billing/*" element={<PortalCheck portalPath="/store/auto_billing/dashboard" portalList={portalAccessList}><AutoBillingPortal /></PortalCheck>} />
                    <Route path="/meeting/*" element={<PortalCheck portalPath="/store/meeting/dashboard" portalList={portalAccessList}><MeetingPortal /></PortalCheck>} />
                    <Route path="/store_panel_content" element={<></>} />
                </Routes>
        </Suspense>
    );

}

export default StoreRoutes;
